export const MARINER_SUPPORT_EMAIL = "marinersupport@toteservices.com";
